import axios from "axios";
import ErrorManager from "@/helpers/errorManager";
import { getCsrfToken } from "@/helpers/configHelpers";

// HTTP Service for Evessio requests
let evessioHttpService = axios.create({
  baseURL:
    window.location.origin +
    window.location.pathname
      .split("/")
      .slice(0, 3)
      .join("/")
});

evessioHttpService.interceptors.request.use(
  config => {
    config.headers["X-CSRFToken"] = getCsrfToken();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

evessioHttpService.interceptors.response.use(
  config => config,
  error => {
    ErrorManager.handleError(error);
    return Promise.reject(error);
  }
);

export { evessioHttpService };
